const ASSET_PROBE_RETRY_MS = 750;
const ASSET_PROBE_TIMEOUT_MS = 8_000;

function expectedAssetMime(assetPath: string): string {
  return assetPath.endsWith(".css") ? "text/css" : "javascript";
}

async function probeOnce(assetPath: string): Promise<boolean> {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), ASSET_PROBE_TIMEOUT_MS);
  try {
    const response = await fetch(assetPath, {
      cache: "reload",
      credentials: "same-origin",
      headers: {
        accept: assetPath.endsWith(".css") ? "text/css" : "application/javascript,text/javascript",
      },
      signal: controller.signal,
    });
    const contentType = response.headers.get("content-type") || "";
    if (!response.ok || !contentType.includes(expectedAssetMime(assetPath))) return false;
    await response.arrayBuffer();
    return true;
  } catch {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}

/** Verify the exact failed immutable asset, with one bounded transient retry. */
export async function probeChunkAsset(assetPath: string): Promise<boolean> {
  if (!assetPath.startsWith("/_next/static/")) return false;
  if (await probeOnce(assetPath)) return true;
  await new Promise<void>((resolve) => setTimeout(resolve, ASSET_PROBE_RETRY_MS));
  return probeOnce(assetPath);
}
